import costaRicaCodes from "./costa-rica-codes.json";
import panamaCodes from "./panama-codes.json";
import {
  createAddressRegistry,
  cantonsToComboBoxItems,
  districtsToComboBoxItems,
  getCantonComboBoxValue,
  getDistrictComboBoxValue,
  getProvinceComboBoxValue,
  provincesToComboBoxItems,
} from "./addressRegistry";
import type {
  Canton,
  District,
  Province,
  ComboBoxItem,
} from "./addressPickerTypes";

export type {
  Canton,
  District,
  Province,
  ComboBoxItem,
} from "./addressPickerTypes";
export type { AddressCodesJson } from "./addressRegistry";

export { createAddressRegistry };

/**
 * Registro por defecto (Costa Rica).
 */
export const costaRicaAddressRegistry = createAddressRegistry(
  costaRicaCodes as import("./addressRegistry").AddressCodesJson
);

/**
 * Registro para Panamá (provincia / distrito / corregimiento; mismos códigos internos).
 */
export const panamaAddressRegistry = createAddressRegistry(
  panamaCodes as import("./addressRegistry").AddressCodesJson
);

// ——— API compatible con el código existente (Costa Rica) ———

const cr = costaRicaAddressRegistry;

export const createProvinces = cr.createProvinces;
export const createCantons = cr.createCantons;
export const createDistricts = cr.createDistricts;
export const loadProvinceSelection = cr.loadProvinceSelection;
export const loadCantonSelection = cr.loadCantonSelection;
export const loadDistrictSelection = cr.loadDistrictSelection;
export const resolveLocationLabelsForDb = cr.resolveLocationLabelsForDb;

export const filterCantonsByProvince = (
  cantons: Canton[],
  selectedProvince: Province | null
) => {
  return selectedProvince
    ? cantons.filter((c) => c.province === selectedProvince.id)
    : [];
};

export const filterDistrictsByCanton = (
  districts: District[],
  selectedCanton: Canton | null
) => {
  return selectedCanton
    ? districts.filter((d) => d.canton === selectedCanton.id)
    : [];
};

export const handleProvinceChange = (
  prov: Province | null,
  currentCanton: Canton | null,
  currentDistrict: District | null
) => {
  return {
    selectedProvince: prov,
    selectedCanton: null,
    selectedDistrict: null,
    province: prov ? prov.id.toString() : 0,
    canton: 0,
    district: 0,
  };
};

export const handleCantonChange = (
  cant: Canton | null,
  currentDistrict: District | null
) => {
  return {
    selectedCanton: cant,
    selectedDistrict: null,
    canton: cant ? (cant.id % 100).toString().padStart(2, "0") : 0,
    district: 0,
  };
};

export const handleDistrictChange = (dist: District | null) => {
  return {
    selectedDistrict: dist,
    district: dist ? (dist.id % 100).toString().padStart(2, "0") : 0,
  };
};

export {
  provincesToComboBoxItems,
  cantonsToComboBoxItems,
  districtsToComboBoxItems,
  getProvinceComboBoxValue,
  getCantonComboBoxValue,
  getDistrictComboBoxValue,
};
